import { render, staticRenderFns } from "./ConfiguracaoIntegracoes.vue?vue&type=template&id=91cc0840&"
import script from "./ConfiguracaoIntegracoes.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoIntegracoes.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoIntegracoes.vue?vue&type=style&index=0&id=91cc0840&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports